var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22.4 20.2",
    style: {
      enableBackground: "new 0 0 22.4 20.2"
    },
    xmlSpace: "preserve",
    width: "20px",
    height: "20px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#020202;}\n\t.st1{clip-path:url(#SVGID_00000017482932857051391270000002187643170940966806_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#092540;}\n\t.st3{fill:#20201F;}\n\t.st4{fill:none;stroke:#020202;stroke-width:1.3871;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#20201F;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#20201F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#20201F;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.3,20.2v-4.7H0V0h22.4v15.4h-11L6.3,20.2z M1.4,14h6.3v3l3.3-3h10.1V1.4H1.4V14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.5,4.9H4.9c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7h12.6c0.4,0,0.7,0.3,0.7,0.7S17.9,4.9,17.5,4.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.5,8.4H4.9c-0.4,0-0.7-0.3-0.7-0.7S4.5,7,4.9,7h12.6c0.4,0,0.7,0.3,0.7,0.7S17.9,8.4,17.5,8.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.3,11.9H4.9c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7h8.4c0.4,0,0.7,0.3,0.7,0.7S13.7,11.9,13.3,11.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactSupport);
export default __webpack_public_path__ + "static/media/contact-support.6406a3db.svg";
export { ForwardRef as ReactComponent };